import LazyLoad from "react-lazyload";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { PropTypes } from "prop-types";

import { gaCustomEvent } from "../../context/helpers";
import useResponsiveWithHydrationFix from "../../hooks/useResponsiveWithHydrationFix";

import { ALButton, ALSkeleton, ALLink as Link } from "../ALComponents";

import * as Styles from "./collectionTile/collectionTileStyles.module.scss";

function CollectionTileImage({ image }) {
  const imgMobile = image ? (
    <LazyLoad
      style={{ width: "100%", height: "68vw" }}
      once
      placeholder={<ALSkeleton width="100%" height="100%" />}
    >
      <GatsbyImage
        className={Styles.tile_content_image}
        image={getImage(image.mobileImage.gatsbyImageData)}
        alt={image.altText}
      />
    </LazyLoad>
  ) : null;

  const imgDesktop = image ? (
    <LazyLoad
      style={{ width: "100%", height: "100%" }}
      once
      placeholder={<ALSkeleton width="100%" height="100%" />}
    >
      <GatsbyImage
        className={Styles.tile_content_image}
        image={getImage(image.desktopImage.gatsbyImageData)}
        alt={image.altText}
      />
    </LazyLoad>
  ) : null;

  const imgCollection = useResponsiveWithHydrationFix(imgMobile, imgDesktop);
  return imgCollection;
}

function CollectionTile({ content }) {
  if (content?.title === "null") {
    return null;
  }

  const onLinkClick = (title) => {
    gaCustomEvent("Collection Tile Link", "Click", title);
  };

  if (content) {
    return (
      <div
        className={`${Styles.tiles_container} ${
          content.addPadding ? Styles.tiles_container_padding : ""
        } id-${content.contentful_id}`}
      >
        {content.collections?.map((c, i) => (
          <div className={Styles.tile_content} key={`home_categorie_${i}`}>
            <Link
              className={Styles.tile_content_link}
              to={`${c.link.link.link}`}
              onClick={() => onLinkClick(c.title)}
            >
              <CollectionTileImage image={c.images[0]} />

              {c.tag && c.tag.title !== "null" && (
                <span
                  className={`${Styles.tiles_container_tag} microtext microtext--bold microtext--uc`}
                  style={{
                    backgroundColor: c.tag.backgroundColor || "#000",
                    color: c.tag.textColor || "#FFF",
                  }}
                >
                  {c.tag.title}
                </span>
              )}

              <ALButton
                className={Styles.tile_content_button}
                variant="primary"
                buttonBackgroundColor={c.link?.buttonBackgroundColor}
                buttonTextColor={c.link?.buttonTextColor}
              >
                {c.title}
              </ALButton>
            </Link>
          </div>
        ))}
      </div>
    );
  }
  return null;
}

CollectionTile.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    addPadding: PropTypes.bool,
    contentful_id: PropTypes.string,
    collections: PropTypes.array,
  }),
};

export default CollectionTile;
